import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Cookies from 'js-cookie';
import { KBD } from "./Keybindings";
import { ROUTES } from "./Routes";
import EmployeeLogin from "../popups/EmployeeLogin";
import { createModal } from "../hooks/createModal";
import { showMessage } from "../ui/Message";
import Help from "../popups/Help";
import Confirm from "../popups/Confirm";
import play_scanned from "../media/scanned.wav";
import play_short from "../media/short.wav";
import play_even from "../media/agree.wav";
import play_over from "../media/over.wav";
import play_not_found from "../media/notfound.wav";
import play_months from "../media/oldstock.wav";
import Info from "../popups/Info";
import ClerkCode from "../popups/ClerkCode";
import GlobalClassFile from "../popups/GlobalClassFile";
import Prompt from "../popups/Prompt";
import Options from "../popups/Options";
import { ENUMS } from "./Enums";



export const playSounds = (_arr) => {
  const soundMap = {
    play_scanned,
    play_short,
    play_even,
    play_over,
    play_not_found,
    play_months,
  };

  const playSound = (sound) => {
    return new Promise((resolve) => {
      const audio = new Audio(sound);
      audio.play();
      audio.onended = () => resolve();
    });
  }

  _arr.reduce((promise, soundName) => {
    const sound = soundMap[soundName];
    return promise.then(() => playSound(sound));
  }, Promise.resolve());
}


export const purgeReplace = (arr, newItem, key, id = "") => {
  const index = arr.findIndex(item => item.filter_id === id);
  if (index !== -1) {
    arr[index] = newItem;
  } else {
    arr.push(newItem);
  }

  return arr;
}

export const updateOrdering = (array) => {
  return array.map((item, index) => ({
    ...item,
    ordering: index
  }));
}




export const convertDiscountToInt = (_discount, _profit_margin = 40) => {

        if (_discount == 'SH') {
            _discount = 40;
        }

        if (_discount == 'RG') {
            _discount = _profit_margin;
        }

        if (_discount == 'BX' || _discount == 'HI' || _discount == '') {
            _discount = 40;
        }

        if (_discount == 'NT') {
            _discount = 0;
        }
        _discount -= 0;
        return _discount;
    }

export const stringToFile = (_filename, _string, _extension = ".csv") => {

  const blob = new Blob([_string], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', _filename + _extension);

  // Simulate a click on the link to trigger the download
  link.click();

  // Clean up
  URL.revokeObjectURL(url);
};

export const centsToPrice = (cents) => {
  if (!isNaN(cents)) {
    return (cents / 100).toFixed(2);
  }
}

export const ageInDays = (_date) => {
  const givenDate = dayjs(_date);
  const today = dayjs().startOf('day');
  return today.diff(givenDate.startOf('day'), 'day');
}



export const month_labels = () => {
  let _date = dayjs();
  return Array.from({ length: 14 }, (_, index) => {
    return _date.subtract(index, 'month').format('MMM');
  }).reverse();
}

// only has title-link data
export const istl = (_f) => {
  if (_f?.stock_id.includes("no-stock")) {
    return true;
  } else {
    return false
  }
}


export const drawPOSStatus = (_invoice = "") => {
  let _char = _invoice.slice(0, 1);
  if (_char === "H") { return "Held" }
  if (_char === "Q") { return "Quote" }
  return "History";
}

// Remove keys from obj2 that obj1 doesn't have
export const removeExcess = (obj1, obj2) => {
  const filteredObj2 = Object.keys(obj2)
    .filter(key => key in obj1)
    .reduce((acc, key) => {
      acc[key] = obj2[key];
      return acc;
    }, {});

  return filteredObj2;
}

// Formats a timestamp to a string like "14:30" or "2:30 PM"
export function bm_time(timestamp, _seconds = false) {
  const date = dayjs(timestamp);

  if (!date.isValid()) return "";

  const hours = date.hour().toString().padStart(2, "0");
  const minutes = date.minute().toString().padStart(2, "0");

  if (_seconds) {
    const seconds = date.second().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  }

  return `${hours}:${minutes}`;
}

// Parses a string like "14:30" or "2:30 PM" to a timestamp (today's date + time)
export function parseToTime(input) {
  if (!input) return null;

  input = input.trim().toLowerCase();


  const now = new Date();
  const baseDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // Try HH:mm 24-hour format first
  const match24 = input.match(/^(\d{1,2}):(\d{2})$/);
  if (match24) {
    let [_, h, m] = match24;
    const hours = parseInt(h, 10);
    const minutes = parseInt(m, 10);
    if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
      baseDate.setHours(hours, minutes, 0, 0);
      return baseDate.getTime();
    }
  }

  // Try HHmm format (no colon, e.g. 1015, 930, 800)
  const matchHHmm = input.match(/^(\d{1,2})(\d{2})$/);
  if (matchHHmm) {
    let [_, h, m] = matchHHmm;
    const hours = parseInt(h, 10);
    const minutes = parseInt(m, 10);
    if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
      baseDate.setHours(hours, minutes, 0, 0);
      return baseDate.getTime();
    }
  }

  // Try 12-hour with optional minutes and am/pm
  const match12 = input.match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm)?$/);
  if (match12) {
    let [_, h, m, period] = match12;
    let hours = parseInt(h, 10);
    let minutes = m ? parseInt(m, 10) : 0;

    if (period) {
      if (hours === 12) {
        hours = period === "am" ? 0 : 12;
      } else {
        hours = period === "pm" ? hours + 12 : hours;
      }
    }

    if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
      baseDate.setHours(hours, minutes, 0, 0);
      return baseDate.getTime();
    }
  }

  return null; // failed to parse
}



export const mergeArraysByKey = (arr1, arr2, key) => {
  const map = new Map();
  arr2.forEach(item => map.set(item[key], { ...item }));
  arr1.forEach(item => map.set(item[key], { ...item }));
  return Array.from(map.values());
}

export const removeByKey = (arr1, arr2, key) => {
  const removeSet = new Set(arr2.map(item => item[key]));
  return arr1.filter(item => !removeSet.has(item[key]));
}


export const getToday = () => {
  return dayjs().format("YYYY-MM-DD");
};

export const getYesterday = () => {
  return dayjs().add(-1, "day").format("YYYY-MM-DD");
};

export const convertDate = (input, _from, _to = "unix") => {

  dayjs.extend(utc);
  dayjs.extend(customParseFormat);

  const parsedDate = dayjs(input, _from);

  if (parsedDate.isValid()) {
    if (_to === "unix") {
      return parsedDate.utc().unix()
    } else {
      return parsedDate.format(_to);
    }
  }

  return "";

}


export const bm_date = (input, format = "MMMDD-YY") => {

  if (!input) return '';
  if (input) { input = input.toString().trim() }

  input = String(input).trim();
  dayjs.extend(utc);
  dayjs.extend(customParseFormat);



  let parsedDate;

  // Check for YYYY
  if (/^\d{4}$/.test(input)) {
    parsedDate = dayjs(input, 'YYYY');
  }
  // Check for YYYYMM
  else if (/^\d{6}$/.test(input) && parseInt(input.substring(0, 2), 10) >= 13) {
    parsedDate = dayjs(input, 'YYYYMM');
  }
  // Check for YYYYMMDD
  else if (/^\d{8}$/.test(input)) {
    parsedDate = dayjs(input, 'YYYYMMDD');
  }
  // Check for YYYY-MM-DD
  else if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
    parsedDate = dayjs(input, 'YYYY-MM-DD');
  }
  // Check for MMDDYY
  else if (/^\d{6}$/.test(input) && parseInt(input.substring(0, 2), 10) <= 12) {
    parsedDate = dayjs(input, 'MMDDYY');
  }
  // Check if it's a timestamp (milliseconds or seconds)
  else if (/^\d+$/.test(input)) {
    parsedDate = input.length <= 10 ? dayjs.unix(input) : dayjs(parseInt(input, 10));
  }
  // Invalid
  else { return ''; }

  return parsedDate.isValid() ? parsedDate.utc().format(format) : '';
};


export const emptyObj = (obj) => {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}


export const diffObjs = (obj1, obj2, keysToCheck = null) => {
  const keys = keysToCheck || Object.keys({ ...obj1, ...obj2 });

  for (let key of keys) {
    if (obj1[key] !== obj2[key]) {
      return true; // Objects are different
    }
  }

  return false; // Objects are the same
}

export const monthsOld = (_timestamp) => {
  // Calculate the age of the timestamp in months
  const timestampMilliseconds = _timestamp * 1000;
  const currentDate = new Date();
  const timestampDate = new Date(timestampMilliseconds);
  const monthsDiff = (currentDate.getFullYear() - timestampDate.getFullYear()) * 12 + (currentDate.getMonth() - timestampDate.getMonth());
  return monthsDiff;
}

export const bm_date_to_timestamp = (_date) => {
  dayjs.extend(utc);
  _date = bm_date(_date);
  if (_date) {
    let _ret = dayjs(_date, 'MMMDD-YY').utc().unix();
    _ret = _ret * 1000;
    return _ret;
  } else {
    return null;
  }
}


export const getBindingLabel = (code, include_code = true) => {
  if (!code) return "";
  const option = ENUMS.BINDINGS.find(opt => opt.value === code);
  if (!option) return code;
  return include_code ? option.label : option.label.replace(/^([A-Z]{2})\s/, "");
}


export const parseToTimestamp = (str) => {
  let parsed;
  if (!str) return null;

  // Try native date
  parsed = dayjs.utc(str);


  // Custom YY pivot (example: 00-49 → 2000-2049, 50-99 → 1950-1999)
  if (parsed.year() < 100) {
    const fullYear = parsed.year() <= 49 ? 2000 + parsed.year() : 1900 + parsed.year();
    parsed = parsed.year(fullYear);
    if (!parsed.isValid()) return null;  // Re-validate
  }

  return parsed.isValid() ? parsed.unix() : null;
};


export const ucfirst = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const isISBN = (isbn) => {
  // Validate that the input is a 13-digit number
  if (!/^\d{13}$/.test(isbn)) {
    return false;
  } else {
    return true;
  }
}


export const combineObjects = (obj1, obj2) => {
  const result = { ...obj1 };
  // Iterate over the keys of obj2
  for (let key in obj2) {
    // Replace only if key exists in obj1
    if (key in obj1) {
      result[key] = obj2[key];
    }
  }

  return result;
}

export const addISBNDashes = (_isbn, _condition = "", _dashes = true) => {

  if (!isISBN(_isbn)) {
    return _isbn;
  }

  if (!_condition || _condition === " ") {
    _condition = _isbn.slice(12, 13);
  }
  // Format the ISBN with dashes
  let formattedISBN = `${_isbn.slice(0, 3)}${_isbn.slice(3, 4)}${_isbn.slice(4, 7)}${_isbn.slice(7, 12)}${_condition}`;

  if (_dashes) {
    formattedISBN = `${_isbn.slice(0, 3)}-${_isbn.slice(3, 4)}-${_isbn.slice(4, 7)}-${_isbn.slice(7, 12)}-${_condition}`;
  }

  if (_condition) {

  }
  return formattedISBN;

}

function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}

export const writeXLSX = (_filename, _data) => {
  const blob = new Blob([s2ab(atob(_data))], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = _filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}



export const writeFile = (_filename, _data) => {
  const blob = new Blob([_data], { type: 'text/plain' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = _filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const getClerkName = (_code) => {
  
  let _f = window?.employees.find(item => item.clerk_code === _code);
  if(_f){
    return _f.name;
  } else {
    return "No Name"
  }

}

export const buildFileFromChunks = (fileMeta, pubCall, setLoading, onComplete) => {
  let byteOffset = 0;
  const byteLimit = 750000; // bytes per chunk
  let fileData = [];
  setLoading(true);
  const fetchNextChunk = () => {
    pubCall("file.getChunk", { file_name: fileMeta.file_name, folder: fileMeta?.folder, tmp_storage: fileMeta.tmp_storage, byte_offset: byteOffset, byte_limit: byteLimit }, (_s, _r) => {
      if (!_s) {
        setLoading(false);
        return console.error("Error fetching chunk:", _r);
      }
      // Decode base64
      const chunk = Uint8Array.from(atob(_r), c => c.charCodeAt(0));
      fileData.push(chunk);
      byteOffset += chunk.length;
      if (byteOffset < fileMeta.size) {
        fetchNextChunk();
      } else {
        const fullFile = new Blob(fileData, {
          type: fileMeta.type || "application/octet-stream"
        });
        setLoading(false);
        if (typeof onComplete === "function") {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(fullFile);
          link.download = fileMeta.file_name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          onComplete(true);
        }
      }
    }
    );
  };

  fetchNextChunk();
};





export const drawPrice = (_num, _from_int = false) => {
  if (isNaN(parseInt(_num))) {
    return "";
  } else {
    if (_from_int) {
      _num = _num / 100;
    }
    return Number(_num).toFixed(2);
  }
}

export const drawQty = (_num) => {
  if (isNaN(parseInt(_num))) {
    return "";
  } else {
    return (_num && _num !== 0 && _num !== "0") ? _num : "";
  }
}

// Some statefull bs here, because 
export const filterPrice = (input) => {
  let filtered = input.replace(/[^0-9.]/g, '');

  // Remove extra dots
  const dotCount = (filtered.match(/\./g) || []).length;
  if (dotCount > 1) {
    const first = filtered.indexOf('.');
    filtered = filtered.slice(0, first + 1) + filtered.slice(first + 1).replace(/\./g, '');
  }

  const [integerPart, decimalPart] = filtered.split('.');
  if (decimalPart !== undefined) {
    filtered = integerPart + '.' + decimalPart.substring(0, 2);
  }

  // Keep raw string if empty or ends with dot (e.g., "10." or "10.0")
  if (filtered === '' || filtered.endsWith('.') || filtered.endsWith('.0')) {
    return filtered;
  }

  return parseFloat(filtered);
};

// Some statefull bs here, because 
export const filterDecimal = (input) => {
  let filtered = input.replace(/[^0-9.]/g, ''); // Remove any character that is not a number or a decimal point
  if ((filtered.match(/\./g) || []).length > 1) {
    filtered = filtered.substring(0, filtered.lastIndexOf('.')); // Ensure only one decimal point
  }
  const [integerPart, decimalPart] = filtered.split('.');
  if (decimalPart !== undefined) {
    filtered = integerPart + '.' + decimalPart.substring(0, 3); // Allow up to 3 decimal places
  }
  if (filtered === '' || filtered.endsWith('.')) {
    return filtered; // Return the filtered value if it is empty or ends with a dot
  }

  return parseFloat(filtered); // Return as a float
}


export const filterChars = (_input, _chars = []) => {
  let filtered = _input.split('').filter(char => _chars.includes(char));
  return filtered.join('');
}

export const getConditionNameFromCode = (_code = "") => {
  const match = window.settings.condition_codes.find(item => item.code === _code);
  return match ? match.description : "New";

}

export const getByKey = (arr, key, value) => {
  return arr.find(item => item[key] === value) || null;
}

export const filterNumber = (_input, _default = null) => {

  console.log("called")
  if (_input === "-") { return _input; }
  let filtered = _input.replace(/[^0-9-.]/g, '');
  return parseFloat(filtered) || _default;
}

export const filterAlpha = (_input, _default = "") => {
  if (typeof _input !== 'string') return _default;
  const filtered = _input.replace(/[^a-zA-Z]/g, '');
  return filtered || _default;
};


//TODO
export const drawNote = (_notes = "") => {
  if (!_notes) { return ""; }

  let flags = ["^^", "//%", "//$", "//@", "//?", "//O"];
  let _split = _notes.split(" ");
  // Only highlight the first instance of any type
  let highlightedFlags = new Set();

  for (let i = 0; i < _split.length; i++) {
    for (let flag of flags) {
      if (_split[i].substring(0, flag.length) === flag) {
        if (!highlightedFlags.has(flag)) {
          _split[i] = "<span style='color:#f12a46;'>" + _split[i] + "</span>";
          highlightedFlags.add(flag);
        }
      }
    }
  }

  _notes = _split.join(" ");
  return <div><div
    dangerouslySetInnerHTML={{ __html: _notes }}
  /></div>;
}





export const drawNumber = (_num) => {

  //return _num; 

  if (_num === 0 || _num === "0") {
    return "";
  } else {
    return _num;
  }
}

export const drawSize = (_width, _height) => {
  if (_width && _height) {
    return _width + "” x " + _height + "”";
  } else {
    return "";
  }
}

export const drawPC = (_cost, _pm, _ps) => {
  if (!_cost || !_pm || !_ps) { return ""; }
  // Bad data replace with stars...
  if (_pm > 99 || _pm < 0) { _pm = "**"; }
  if (_ps > 99 || _ps < 0) { _ps = "**"; }

  _cost = _cost.toString().replace(".", "");
  // only if profit_margin doesn't match profit_sell
  if (_ps !== _pm) {
    return _ps.toString() + "|" + _pm.toString() + _cost.toString().padStart(5, '0');
  }
  return _pm.toString() + _cost.toString().padStart(5, '0');
}

export async function copyToClipboard(text, _message = "Copied to clipboard.") {
  try {
    await navigator.clipboard.writeText(text);
    showMessage(_message)
  } catch (err) {
  }
}

export const splitClassString = (_class) => {
  const parts = _class.split('-').map(str => str.trim());
  return {
    class_1: parts[0] || "",
    class_2: parts[1] || ""
  };
}


export const changeBMState = (expectedValue, varName = "bmstate") => {
  window[varName] = ""
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      window[varName] = expectedValue;
      if (window[varName] === expectedValue) {
        clearInterval(interval);
        resolve();
      }
    }, 1);
  });
}

export const removeKey = (obj, keyToRemove) => {
  const { [keyToRemove]: _, ...newObj } = obj;
  return newObj;
};

export const save = (key, obj) => {
  Cookies.set(key, JSON.stringify(obj));
}

export const getSaved = (key) => {
  const objStr = Cookies.get(key);
  return objStr ? JSON.parse(objStr) : null;
}

export const areAll = (obj, _value = true, _exclude = []) => {
  return Object.entries(obj).filter(([key]) => !_exclude.includes(key)).every(([, value]) => value === _value);
};


export const fillTemplate = (template, values) => {
  return Object.fromEntries(
    Object.entries(template).map(([key, defaultValue]) => [
      key,
      key in values ? values[key] : defaultValue
    ])
  );
}


export const setAll = (obj, _value = true, _exclude = []) => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && !_exclude.includes(key)) {
      obj[key] = _value;
    }
  }
  return obj;
}

export const kbdEvent = (args) => {

  const { key, code, keyCode, altKey = false, ctrlKey = false, } = args; 
  
  const event = new KeyboardEvent('keydown', {
    key: key,
    code: code,
    altKey: altKey,
    ctrlKey: ctrlKey,
    keyCode: keyCode,
    charCode: keyCode,
    bubbles: false,
    cancelable: true,
  });


  window.k.dispatchEvent(event);
}

export const barcodeScan = (barcode) => {

  alert("called")
  // Ensure the barcode starts with '~' and has 13 numbers followed by Enter
  if (barcode.length !== 14 || barcode[0] !== '~' || !/^\~\d{13}$/.test(barcode)) {
    console.error("Invalid barcode format");
    return;
  }

  // Dispatch the '~' prefix
  kbdEvent({ key: '~', code: 'Digit192', keyCode: 192 });

  // Dispatch each number in the barcode
  for (let i = 1; i <= 13; i++) {
    const digit = barcode[i];
    const keyCode = digit.charCodeAt(0);
    kbdEvent({ key: digit, code: `Digit${digit}`, keyCode: keyCode });
  }

  // Dispatch the Enter key event at the end
  kbdEvent({ key: 'Enter', code: 'Enter', keyCode: 13 });
};


const permissionLabels = {
  "adjust_onhand": "Adjust O/H",
  "ap": "A/P",
  "class_editing": "Class file editing",
  "database_repair_utility": "Database repair utilities",
  "edit_onhand_no_tracking": "Edit O/H (no tracking)",
  "frequent_buyer_points": "Frequent Buyer points",
  "gl_book_keeping": "GL (bookkeeping)",
  "gl_confidential_info": "GL (confidential info)",
  "inventory_stats": "Inventory Stats",
  "master": "Master (unrestricted)",
  "ordering_processing": "Ordering & processing",
  "pos_edit_delete": "POS Edit/Delete",
  "pos_new_edit_delete": "POS New/Edit/Delete",
  "pos_sales_tape_date_totals": "POS sales tapes & date-range totals",
  "pos_subtotaling": "POS subtotalling",
  "pos_totaling": "POS totalling",
  "pos_z_no_sale": "POS Z NoSale transactions",
  "q_sales_entry": "Qsales entry",
  "setup_options": "Setup options"
};

export const permissionLabel = (key) => {
  return permissionLabels[key] || key;
}


export const getAdjacent = (array, deletedItem, key, defaultItem = {}) => {
  const index = array.findIndex(item => item[key] === deletedItem[key]);
  if (index !== -1) {
    if (index < array.length - 1) {
      // Return the next item
      return array[index + 1];
    } else if (index > 0) {
      // Return the previous item
      return array[index - 1];
    }
  }
  return defaultItem;
};

const navigate = (
  row_key,
  data,
  selected,
  setSelected,
  step,
  direction,   // "next" or "prev"
  setAlign,
  buffer,
  loading,
  fetchNext,
  fetchPrev,
) => {
  if (!data || data.length === 0) {
    setSelected({});
    return;
  }

  const currentIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]);
  if (currentIndex === -1) return;

  const newIndex = direction === "next" ? currentIndex + step : currentIndex - step;

  if (direction === "next" && setAlign) setAlign("auto");

  if (direction === "next" && newIndex >= data.length - buffer && !loading) {
    fetchNext && fetchNext(true);
  } else if (direction === "prev" && newIndex < 2 && !loading) {
    fetchPrev && fetchPrev(true);
  }

  const clampedIndex = Math.max(0, Math.min(newIndex, data.length - 1));


  setSelected(data[clampedIndex]);
};

export const nextRow = (
  row_key,
  data,
  selected,
  setSelected,
  step = 1,
  buffer = 5,
  loading = false,
  fetchNext = () => { },
  setAlign = () => { },
  fetchPrev = () => { }
) => {
  navigate(row_key, data, selected, setSelected, step, "next", setAlign, buffer, loading, fetchNext, fetchPrev);
};

export const prevRow = (
  row_key,
  data,
  selected,
  setSelected,
  step = 1,
  loading = false,
  fetchPrev = () => { },
  fetchNext = () => { },
  buffer = 5,
  setAlign = () => { }
) => {
  navigate(row_key, data, selected, setSelected, step, "prev", setAlign, buffer, loading, fetchNext, fetchPrev);
};

export const showCategorySelector = ({ route = "", description = <></>, callback = () => { }, title = "Confirm", width = 300 }) => {


  route = (route) ? route : window.bm_state.value;
  window.bm_state.value = ROUTES.HELPERS.CLASS_SELECTOR;
  createModal({

    component: <GlobalClassFile category_1={""} category_2={""} route={ROUTES.HELPERS.CLASS_SELECTOR} />, closable: true, title: title, callback: (e) => {
      window.bm_state.value = route;
      callback(e);
    }
  })
}


export const showConfirm = ({ controller = "", route = "", description = <></>, callback = () => { }, title = "Confirm", width = 300 }) => {
  window.bm_state.value = ROUTES.HELPERS.CONFIRM;
  createModal({
    alert: true,
    component: <Confirm controller={controller} buttons={true} title={title} description={description} width={width} callback={callback} route={ROUTES.HELPERS.CONFIRM} />, closable: true, title: title, callback: (e) => {
      window.bm_state.value = route;
      callback(e);
    }
  })
}

export const showOptions = ({ controller = "", closeable = true, route = "", menu = [], start_index = 0, description = <></>, callback = () => { }, title = "Confirm", width = 300 }) => {
  window.bm_state.value = ROUTES.HELPERS.OPTIONS;
  createModal({
    alert: true,
    component: <Options controller={controller} closeable={closeable} start_index={start_index} menu={menu} title={title} description={description} width={width} callback={callback} route={ROUTES.HELPERS.OPTIONS} />, closable: closeable, title: title, callback: (e) => {
      window.bm_state.value = route;
      callback(e);
    }
  })
}

export const showInfo = ({ controller = "", route = "", description = <></>, callback = () => { }, title = "Info", width = 300, type = "info" }) => {
  window.bm_state.value = ROUTES.HELPERS.INFO;
  createModal({
    alert: true,
    component: <Info controller={controller} type={type} buttons={true} title={title} description={description} width={width} callback={callback} route={ROUTES.HELPERS.INFO} />, closable: true, title: title, callback: (e) => {
      window.bm_state.value = route;
      callback(e);
    }
  })
}



export const showHelp = ({ controller = "", route = "", component = <></>, callback = () => { }, title = "Login to edit rights", width = 300 }) => {
  window.bm_state.value = ROUTES.HELPERS.HELP;
  createModal({
    component: <Help controller={controller} component={component} width={width} callback={callback} route={ROUTES.HELPERS.HELP} />, closable: true, title: title, callback: (e) => {
      window.bm_state.value = route;
      callback(false)
    }
  })
}


export const calculateSellPrice = (_publish_price, _discount, _profit_margin, _exchange = 1) => {
  _discount -= 0;
  var sellp = - (_exchange * _publish_price * ((100 - _discount) / 100)) / ((_profit_margin / 100) - 1);
  if (isNaN(sellp)) {
    return '';
  }
  return sellp.toFixed(2);
}

export const calculateProfitMargin = (_sell_price, _publish_price, _discount, _exchange = 1) => {

  _discount -= 0;
  _sell_price -= 0;
  if (!_sell_price) {
    return '';
  }
  var pm = 1 - ((_exchange * _publish_price * ((100 - _discount) / 100)) / _sell_price);
  pm = Math.round(pm * 100);
  if (isNaN(pm)) {
    pm = '';
  }
  // 100 is impossible, max should be 99
  if (pm === 100) {
    pm = 99;
  }
  if (pm < 0) {
    pm = ""
  }
  return pm;
}


export const toPrice = (val, hide_zeros = false) => {
  const num = Number(val);
  if (hide_zeros && num === 0) return "";
  return num.toFixed(2);
};


export const get14MonthLabels = () => {
  let months = [];
  for (let i = 13; i >= 0; i--) {
    months.push(dayjs().subtract(i, "month").format("MMM").toUpperCase());
  }
  return months.map(m => " " + m).join("");
}


export const showLogin = ({ route = "", login = true, can_login = false, signal = {}, callback = () => { }, title = "Login" }) => {
  // logged in
  if (signal?.value?.session?.clerk_code) {
    callback(true);
    return;
  }
  window.bm_state.value = ROUTES.GLOBAL.EMPLOYEE_LOGIN;
  createModal({
    component: <EmployeeLogin can_login={can_login} login={login} signal={signal} route={ROUTES.GLOBAL.EMPLOYEE_LOGIN} />, closable: true, title: title, callback: (e) => {
      window.bm_state.value = route;
      if (e) {
        callback(e)
      } else {
        callback(false)
      }
    }
  })
}


export const cycleArray = (arr, key, value) => {
  const index = arr.findIndex(item => item[key] === value);
  if (index === -1) return null; // value not found
  const nextIndex = (index + 1) % arr.length;
  return arr[nextIndex];
}


export const requireLogin = ({ route = "", signal = {}, permission = "", callback = () => { }, title = "Login to edit rights" }) => {

  if (signal?.value?.session?.permission[permission] && signal?.value?.session?.clerk_code) {
    callback(true);
    return;
  }

  window.bm_state.value = ROUTES.GLOBAL.EMPLOYEE_LOGIN;
  createModal({
    component: <EmployeeLogin permission={{ ...signal?.value?.session?.permission, [permission]: true }} signal={signal} route={ROUTES.GLOBAL.EMPLOYEE_LOGIN} />, closable: true, title: title, callback: (e) => {
      window.bm_state.value = route;

      if (e?.permission?.[permission]) {
        // has access
        callback(true)
      } else {
        callback(false)
      }
    }
  })
}


export const runEvent = (_str = "", data = {}, callback = null) => {
  const event = new CustomEvent(_str, {
    detail: {
      data: data,
      callback: callback
    }
  });
  window.dispatchEvent(event);
}


export const requestPrompt = ({ controller = "", route = "", title = "Enter", width = 0, inputProps = {}, callback = () => { } }) => {

  window.bm_state.value = ROUTES.HELPERS.PROMPT;
  createModal({
    component: <Prompt controller={controller} inputProps={inputProps} width={width} route={ROUTES.HELPERS.PROMPT} />, closable: true, title: title, callback: (e) => {
      window.bm_state.value = route;
      callback(e);
    }
  })

}


export const requestClerkCode = ({ controller = "", route = "", use_login = true, signal = {}, permission = "", callback = () => { }, bypass = false, title = "Login to edit rights" }) => {



  if (bypass) {
    callback(bypass);
    return;
  }
  // If you are logged in and have the permission, just skip
  if (use_login && signal?.value?.session?.clerk_code) {

    if (permission) {
      if (signal?.value?.session?.permission[permission]) {
        callback(signal?.value?.session?.clerk_code);
        return;
      }
    } else {
      callback(signal?.value?.session?.clerk_code);
      return;
    }


  }

  window.bm_state.value = ROUTES.GLOBAL.REQUEST_CLERK_CODE;
  createModal({
    component: <ClerkCode controller={controller} route={ROUTES.GLOBAL.REQUEST_CLERK_CODE} />, closable: true, title: title, callback: (e) => {

      window.bm_state.value = route;
      if (e === false) {
        callback(false)
      } else {
        callback(e)
      }

    }
  })
}


export const hitTest = (element, x, y) => {
  // Get the bounding rectangle of the element
  if (!(element instanceof Element)) {
    return false;
  }
  const rect = element.getBoundingClientRect();
  // Check if the point (x, y) is within the bounds of the element
  return (
    x >= rect.left &&
    x <= rect.right &&
    y >= rect.top &&
    y <= rect.bottom
  );
}

export const getEnumLabel = (arr = [], value, _key = "label") => {
  const item = arr.find(entry => entry.value === value);
  return item ? item[_key] : "";
}

export const getEnum = (arr = [], value, _key = "label") => {
  const item = arr.find(entry => entry.value === value);
  return item;
}


export const getRowClass = (row) => {
  let { status = "", message = "", sort_key = 2 } = row;

  let _ret = "";


  switch (status) {
    case "Pend":
    case "Ordr":
    case "OSTO":
    case "OEml":
    case "ORep":
    case "OWeb":
    case "OMai":
    case "OFax":
    case "OPhn":
    case "OBkn":
    case "OCnf":
    case "ONet":
    case "OInt":
    case "OAck":
    case "Ship":
    case "ODTH": // Direct to home (not released)
    case "BDTH": // Direct to home (not released)
    case "DTH": // Direct to home (not released)
    case "SDTH": // Direct to home (not released)
    case "BOS":
    case "BNYP":
    case "BRP":
    case "BITO":
    case "BkOr":
      _ret = "text-orange"; // Order Orange (On order)
      break;
    case "Rcvd":
    case "RDTH": // Direct to home (not released)
    case "COS":
    case "CNYP":
    case "CBC":
    case "CBU":
    case "CNOP":
    case "CNR":
    case "COP":
    case "CNL":
    case "CNW":
    case "COSI":
    case "CPXL":
    case "CRP":
    case "CITO":
      _ret = "text-peach"; // Rcvd Peach (Cancelled)
      break;
    case "HRdm":
    case "HPrp":
    case "Held":
      _ret = "text-pink"; // Pink for Held rows
      break;
    case "Return":
    case "SRtn":
      _ret = "text-purple"; // Darker Purple for supplier returns
      break;
    case "PRtn":
      _ret = "text-bright-purple"; // Bright Purple for pending returns
      break;
    case "Quot":
      _ret = "text-teal"; // Teal for quotes
      break;
    case "Trf":
      _ret = "text-light"; // Text Light Grey for transfers
      break;
    case "Adj":
      _ret = "text-red"; // Red for adjustments
      break;
    case "Prpy":
      if (message === "F") {
        _ret = "text-light";
        break;
      }
      _ret = "text-yellow"; // Yellow for prepay
      break;

    case "Sale":
      _ret = "text-light"; // light gray for sale
      break;
    default: _ret = "text-light";
      break;
  }

  if (sort_key === 1) {
    _ret = _ret + " history-active";
  }


  return _ret;

}